export function isInShell(): boolean {
  return window.location.pathname.includes("/app/documents")
}